import { DisplayConfig, Chart } from "../ViewConfig/ConfigProvider";

interface HistoricFetchOptions{
    start: number;
    end: number;
    skid: string;
    view: Map<string,Chart>;
    aggregation: number;
}
function rangeExceedsLimit(start:number, end:number, limitDays:number){
    const limitSeconds = limitDays*60*60*24*1000
    if((end-start)>limitSeconds){
        return true
    }
    return false
}
function validateHistoricFetch(o:HistoricFetchOptions){
    var error:string
    if (o.start>o.end){
        error = `Start ${new Date(o.start).toLocaleString()} is greater than End ${new Date(o.end).toLocaleString()}`
        return error
    }
    if(o.skid==''){
        error= 'No Skid selected'
    }
    if(o.view==null){
        error='No view selected'
    }
    if(rangeExceedsLimit(o.start,o.end,7)){
        error=`Date range exceeds 7 days limit`
        return error
    }
    if(o.aggregation<1){
        error='Aggregation must be greater than 0'
        return error
    }
    
    error ='ok'
    return error
}

export default validateHistoricFetch